export const leadOwnerFilterMapper = (
  acc: any,
  {
    accountUserId,
  }: {
    accountUserId: {
      _id: string;
      fullName?: string;
      firstName: string;
      lastName: string;
      emailAddress: string;
    };
  },
) => {
  if (acc.find((leadOwner: any) => leadOwner.value === accountUserId._id))
    return acc;
  return acc.concat({
    itemLabel:
      accountUserId.fullName ??
      `${accountUserId.firstName} ${accountUserId.lastName}`,
    value: accountUserId._id,
    description: accountUserId.emailAddress,
  });
};

export const accountUserFilterMapper = (
  acc: any,
  accountUser: {
    fullName: string;
    _id: string;
    emailAddress: string;
  },
) =>
  acc.concat({
    itemLabel: accountUser.fullName,
    value: accountUser._id,
    description: accountUser.emailAddress,
  });

export const objectToDropdownElementMapper = (
  acc: any,
  [key, value]: [string, string],
) =>
  acc.concat({
    value: key,
    label: value,
  });

export const companyOwnerFilterMapper = (
  acc: any,
  data: { companyOwner: string; id: string; name: string },
) =>
  acc.concat({
    itemLabel: data.companyOwner,
    value: data.id,
    description: data.name,
  });
